import { jsx } from 'react/jsx-runtime';
import { Box } from '@mui/material';
import { useMemo, useCallback } from 'react';

function escapeRegExp(string) {
    return string.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
}
function MarkedText({ "data-testid": dataTestId, text = "", textToMark = "", markedStyle, }) {
    const regex = useMemo(() => new RegExp(`(${escapeRegExp(textToMark)})`, "gi"), [textToMark]);
    const parts = text.split(regex).filter((part) => part);
    const getTextElement = useCallback((part, key) => {
        if (regex.test(part)) {
            return (jsx(Box, { component: "span", sx: markedStyle, children: part }, key));
        }
        return jsx("span", { children: part }, key);
    }, [markedStyle, regex]);
    if (!textToMark.trim()) {
        return jsx("span", { "data-testid": dataTestId, children: text });
    }
    return jsx("span", { "data-testid": dataTestId, children: parts.map((part, i) => getTextElement(part, i)) });
}

export { MarkedText };
//# sourceMappingURL=MarkedText.js.map
